import { T } from "../../app/tokens.js";

export function getColHeaderHighlight(colKey, activeSortKey, userHasSetSort) {
  if (!userHasSetSort || colKey !== activeSortKey) {
    return {
      background: "none",
      color: "var(--v2-mid)",
      borderBottom: "none",
    };
  }
  return {
    background: T.blueSoft,
    boxShadow: `inset 0 -2px 0 ${T.blue}`,
    color: T.blue,
  };
}

export function getColCellHighlight() {
  return {};
}
